import React, { useContext } from "react";
import styled from "styled-components";
import { Box } from "reflexbox";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const Card = styled(Box)`
  background: rgba(42, 199, 220, 0.03);
  border: 1px solid rgba(42, 199, 220, 0.3);
  border-radius: 12px;
  padding: 20px 24px;
  margin: 20px 0 !important;
`;

const TipLabel = styled(Box)`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary};
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
`;

export function TipCard({ label = "Tip", children }) {
  return (
    <Card>
      <TipLabel>{parseMarkdownLinks(label, { crownPrice: useContext(CrownPriceContext) })}</TipLabel>
      <Box
        fontSize={[14, 15]}
        color={colors.text}
        style={{ lineHeight: "170%" }}
      >
        {children}
      </Box>
    </Card>
  );
}
